// extracted by mini-css-extract-plugin
module.exports = {"matchWrapper":"Lineups_matchWrapper__1-jRj","headerWrapper":"Lineups_headerWrapper__y7EvH","autofillBtn":"Lineups_autofillBtn__3860O","resetBtn":"Lineups_resetBtn__Nu5G4"};